import { css } from '@emotion/react'

export default css`
  .privacy-policy {
      display:flex;
      flex-direction: column;
  }
  .privacy-policy .layout-content {
      overflow:hidden;
  }
`